const ANIMATION_END_EVENTS = ['animationend', 'webkitAnimationEnd']
// Fallback if animationend never fires; interstitial gradient animation is 800ms
const FALLBACK_MS = 1000

export const InterstitialTransition = {
  mounted() {
    this._transitionHandled = false

    this._completeTransition = () => {
      if (this._transitionHandled) return
      this._transitionHandled = true
      if (this._fallbackTimeoutId != null) {
        clearTimeout(this._fallbackTimeoutId)
        this._fallbackTimeoutId = null
      }
      const targetStep = this.el.dataset.transitionTo
      if (targetStep) {
        this.pushEvent('complete-step-transition', { step: targetStep })
      }
    }

    this._onAnimationEnd = event => {
      if (event.target === this.el) {
        this._completeTransition()
      }
    }

    ANIMATION_END_EVENTS.forEach(name => this.el.addEventListener(name, this._onAnimationEnd))

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (prefersReducedMotion) {
      requestAnimationFrame(() => this._completeTransition())
    } else {
      this._fallbackTimeoutId = setTimeout(() => this._completeTransition(), FALLBACK_MS)
    }
  },
  destroyed() {
    ANIMATION_END_EVENTS.forEach(name => this.el.removeEventListener(name, this._onAnimationEnd))
    if (this._fallbackTimeoutId != null) clearTimeout(this._fallbackTimeoutId)
  },
}
